import consentCheck from '@capsule/consent-check'
import generateScriptElement from '@capsule/generate-script-element'
import Observer from '@capsule/observer'
import PmcBridge from 'shared/services/pmc-bridge'

declare global {
	interface Window {
		OBR: {
			extern: {
				researchWidget: () => void
			}
		}
	}
}

export default class Outbrain {
	private outbrainAds: Element[]
	private outbrainVisibleAd: Element | null
	private pmcBridge: PmcBridge
	private outbrainScriptUrl: string

	constructor() {
		this.outbrainAds = [...document.querySelectorAll('.outbrain-ads')]
		this.outbrainVisibleAd = null
		this.pmcBridge = new PmcBridge()
		this.outbrainScriptUrl = 'https://widgets.outbrain.com/outbrain.js'
		this.addObserverOnOutbrainAds = this.addObserverOnOutbrainAds.bind(this)
	}

	async init() {
		const [hasPassPrisma, hasSubscription] = await Promise.all([
			this.pmcBridge.hasPassPrisma(),
			this.pmcBridge.hasSubscription()
		])

		this.findFirstVisibleOutbrainAd()
		if (!hasPassPrisma && !hasSubscription && this.outbrainVisibleAd) {
			this.addObserverOnOutbrainAds()
		}
	}

	findFirstVisibleOutbrainAd() {
		if (this.outbrainAds.length >= 1) {
			this.outbrainVisibleAd = this.outbrainAds[0]
		}
	}

	addEvents() {
		consentCheck('adsConsentGiven', () => this.addObserverOnOutbrainAds())
		consentCheck('allConsentGiven', () => this.addObserverOnOutbrainAds())
	}

	addObserverOnOutbrainAds() {
		const outbrainObserver = new Observer({
			elements: this.outbrainVisibleAd,
			onIntersection: () => {
				const script = generateScriptElement({
					src: this.outbrainScriptUrl
				})

				if (script instanceof Error) {
					console.warn(
						'Outbrain: outbrainObserver: Script variable type is not HTMLScriptElement'
					)
					return
				}

				document.body.appendChild(script)

				script.onload = () => {
					// Trigger Outbrain function after script loaded
					// Function is useful for lazyload ads
					try {
						window.OBR.extern.researchWidget()

						for (const element of this.outbrainAds) {
							element.classList.add('adLoaded')
						}
					} catch {
						console.warn('Outbrain error')
					}
				}
			}
		})
		outbrainObserver.observe()
	}
}
